import React from 'react'
import isStudent from '../../../utilities/is-student'

const StudentId = ({ user }) => {
    if (!isStudent(user)) {
        return null
    }
    return (
        <div style={{
            fontWeight: '500'
        }}>
            ID: {user.studentId || 'N/A'}
        </div>
    )
}

export default StudentId